import React from 'react'
import {Translate} from "react-redux-i18n";
import {Button, Col, Container, Form, Row, Spinner} from "react-bootstrap";
import {withRouter} from "react-router-dom";
import {connect} from "react-redux";
import store from "../store";
import {submitSandboxPayment} from "../providers/providers";


const stateMap = (store) => {
    return {
        user: store.user
    };
};


class SandboxPayments extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            parsedJwt: null,
            rawJwt: null
        }

        SandboxPayments.parseJwt = SandboxPayments.parseJwt.bind(this)
        this.handleSubmit = this.handleSubmit.bind(this)
        this.handleChange = this.handleChange.bind(this)
        this.handleAlert = this.handleAlert.bind(this)
    }

    static parseJwt(token) {
        let base64Url = token.split('.')[1];
        let base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
        let jsonPayload = null;
        try {
            jsonPayload = decodeURIComponent(atob(base64).split('').map(function (c) {
                return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
            }).join(''));
        } catch (e) {
            jsonPayload = null;
        }
        return jsonPayload ? JSON.parse(jsonPayload) : null;
    }

    componentDidMount() {

        let param = this.props.location.search;
        let jwtData = param && param.trim() !== '' ? SandboxPayments.parseJwt(param) : null;
        this.setState({
            rawJwt: param && param.trim() !== '' && SandboxPayments.parseJwt(param) ? param.replace('?details=', '') : null,
            parsedJwt: jwtData
        })
    }

    handleAlert(show) {
        this.setState({
            showError: show
        })
    }


    handleChange(event) {
        this.setState({
            [event.target.id]: event.target.value
        });
    }

    handleSubmit(event) {
        event.preventDefault();
        store.dispatch(submitSandboxPayment(
            this.state.rawJwt
        ))
            .then((response) => {
                if (this.state.parsedJwt !== null && this.state.parsedJwt.tppRedirectUri) {
                    window.location.replace(this.state.parsedJwt.tppRedirectUri)
                }
                this.props.history.push({
                    pathname: '/message',
                    search: '?type=success'
                })
            }, (error) => {
                this.props.history.push({
                    pathname: '/message',
                    search: '?type=error'
                })
            })
    }

    render() {
        let details = this.state.parsedJwt;
        let visualObj = details ? {
            debtorIban: details.debtorAccount.iban,
            creditorName: details.creditorName,
            creditorIban: details.creditorAccount.iban,
            currency: details.instructedAmount.currency,
            amount: details.instructedAmount.amount
        } : undefined;

        if (details && details.creditorAgent) {
            visualObj.creditorAgent = this.state.parsedJwt.creditorAgent;
        }
        let prefix = "payments.fields.";
        return (
            <React.Fragment>
                {this.state.parsedJwt ?
                    <React.Fragment>
                        <Col className="payments__fields--wrapper" lg={{span: 6, offset: 3}}>
                            {Object.keys(visualObj).map((key, idx) => {
                                let label = prefix + key;
                                return <Row className="justify-content-md-center" key={key}>
                                    {idx === 0 ?
                                        <Col lg="10" className="payments-title">
                                            <h1>
                                                <Translate value="payments.title"/>
                                            </h1>
                                        </Col> : null
                                    }
                                    <Col lg="4" className="fields-lbl">
                                        <Translate value={label}/>
                                    </Col>
                                    <Col lg="6">
                                        {visualObj[key]}
                                    </Col>
                                </Row>

                            })}
                        </Col>
                        <Row className="justify-content-md-center">
                            <Col lg="8">
                                <section className="payments-details">
                                    <Container className="payments-frm">
                                        <Row className="justify-content-md-center">
                                            <Col lg="8">
                                                <Form onSubmit={this.handleSubmit}>
                                                    <Col>
                                                        <Row className="justify-content-md-end align-items-end">
                                                            {this.props.user && this.props.user.entity.fetching ?
                                                                <div className="lds-dual-ring"></div> : null}
                                                            <Button variant="warning"
                                                                    className="cancel-btn"
                                                                    onClick={() => {
                                                                        this.props.history.push({
                                                                            pathname: '/message',
                                                                            search: '?type=cancel'
                                                                        })
                                                                    }}
                                                            >
                                                                <Translate value="button.cancel"/>
                                                            </Button>
                                                            <Button variant="info" type="submit"
                                                                    className="proceed-btn">
                                                                <Translate value="button.proceed"/>
                                                            </Button>
                                                        </Row>
                                                    </Col>
                                                    <Row>
                                                        <Col>
                                                            {this.props.user && this.props.user.payment.fetching ?
                                                                <Spinner animation="border" variant="info"
                                                                         className="bs-spinner spinner__custom-clr"/> : null}
                                                        </Col>
                                                    </Row>
                                                </Form>
                                            </Col>
                                        </Row>
                                    </Container>
                                </section>
                            </Col>
                        </Row>
                    </React.Fragment>
                    :
                    <section
                        className='payments__error-page d-flex flex-row justify-content-md-center align-items-center'>
                            <span className='fa fa-times-circle-o error-icon'>
                            </span>
                    </section>
                }
            </React.Fragment>
        )
    }
}


export default withRouter(connect(stateMap)(SandboxPayments));

